import { useSelector } from "react-redux";
import { useParams } from "react-router-dom";

import type { RootState } from "../store/state/rootReducer";

/**
 * The organization that OWNS `projectId` — what project-scoped calls (e.g. the
 * /rag-chat-token mint, which rejects an org that doesn't own the project) must
 * send. Never the user's first org: users in 2+ orgs would send the wrong one.
 *
 * 1. the loaded project record (GET /projects/:id → projectDetails.project), only
 *    when it is this project;
 * 2. else the route's :organization_code org;
 * 3. else "" — callers treat "" as not ready and must not fire requests.
 */
export function useProjectOrgId(projectId?: string | null): string {
  const { organization_code: orgCode } = useParams();
  const fromProject = useSelector((s: RootState) => {
    const project = s.projects?.project?.projectDetails?.project;
    if (!projectId || !project?.organization || String(project._id) !== String(projectId)) return "";
    return String(project.organization);
  });
  const fromRoute = useSelector((s: RootState) =>
    orgCode ? (s.organizations?.organizations?.[orgCode]?._id as string | undefined) || "" : ""
  );
  return fromProject || fromRoute;
}
